
import React, { useEffect, useState } from 'react';
import { CancelButton, CreateButton, ExportButton, FilterButton, ImportButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import { Link, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import SearchBar from '../../../../Components/Utils/SearchBar';
import UseGetData from '../../../../Components/Hooks/useFetchData';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import MoreOptions from '../../../../Components/Utils/MoreOptions';
import CustomDataTable from '../../../../Components/Others/CustomDataTable';
import Card from '../../../../Components/Icons/card';
import List from '../../../../Components/Icons/list';
import Select from 'react-select'
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';
import Pagination from '../../../../Components/Utils/Pagenation';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { NuInput } from '../../../../Components/Utils/Input';
import useFetchMetaStar from '../../../../Components/Hooks/useFetchMetaStar';
import { CountryMIN } from '../../../../assets/CountryMini';

import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import { GetAccess, GetRole } from '../../../../Components/Utils/roles';
import useFetchMDIndex from '../../../../Components/Hooks/useFetchMDIndex';
import useFetchMetaStarIndex from '../../../../Components/Hooks/useFetchMetaStarIndex';

import axiosInstance from '../../../../Services/axiosCommon';
import CloseIcon from '../../../../Components/Icons/Close';
import DataFormat from "../../../../Components/Utils/NuDate"
import UseDropDown from '../../../../Components/Hooks/useDropDown';
import { usePDF } from '@react-pdf/renderer';
import ContactsLayout from '../ContactsLayout';
import CardView from './cardView';
import Importdoc from './Importdoc';
import MultiEdit from './MultiEdit';

const SubCon = () => {
  const {officeId} =useParams();
  const location = useLocation();
  const currentPage= location.state?.currentPage
  const searchQuery= location.state?.searchQuery
  const [page, setPage] = useState(currentPage||1)
  const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20)
  const [viewMode, setViewMode] = useState(localStorage.getItem("viewMode") || "card");
  const [searchBy, setSearchBy] = useState("all");
  const [filter, setFilter] = useState(false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const { data: user } = UseDropDown("/user/drop-down");
  const { value:vendorRating } = useFetchMetaStarIndex(`/dropdown/dropdown-details/`,'vendorRating_supplier',showFilterDialog ||showExport)
  const { value:scStatus } = useFetchMDIndex(`/dropdown/dropdown-details/`,'status_supplier',showFilterDialog ||showExport)
  const { value: subConType, getData: refsubConType } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "subConType_Supplier"
  );  const {value:supplierCat } = useFetchMDIndex(`/dropdown/dropdown-details/`,'SupplierCategory',showFilterDialog ||showExport)
  const [showEdit, setShowEdit] = useState(false)
  const [listofNumbers, setListofNumbers] = useState([])
  const [fullList, setFullList] = useState([])

  const [filterProps, setFilterProps] = useState({
    country:"",  
    scStatus:"",
    performanceRating:"",
    subConType:"",
    category:""
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search:searchQuery||"",

    searchBy: "",
    country:"",
    scStatus:"",
    performanceRating:"",
    category:"",
    subConType:""
  });
  const clearFilter = ()=> {
    setParams({...params, country:"",
    scStatus:"",
    performanceRating:"",category:"",subConType:""})
    formik.values.performanceRating=""
    formik.values.scStatus=""
    formik.values.country=""
    formik.values.subConType=""
    formik.values.category=""

      setFilter(false)
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      console.log("ffff",value);
      setParams({...params,performanceRating:value.performanceRating, scStatus:value.scStatus,country:value.country,createdBy:value.createdBy,category:value.category,subConType:value.subConType})
      closeFilterDialog();
      setFilter(true)
      setFilterProps({
        country:"",
        scStatus:"",
        createdBy:"",
        // isGeneral:"",
        performanceRating:"",
        subConType:"",
        category:""
      });
    }
  })

  const selectOneFunction = (value) =>{ 
    let NewId;
    if(listofNumbers && listofNumbers.some(Item=>Item ===value)){
      NewId = listofNumbers.filter(Temp=> Temp !== value);
      setListofNumbers(NewId)
    }else{
      setListofNumbers([...listofNumbers,value])
    }
  }

  const selectMultipleFunction = (e) =>{ 

if(e.target.checked){
  setListofNumbers(fullList)
}else{
  setListofNumbers([])
}

  }



 
  const { data, totalCount, getData, credit, advance,dataLoading } = UseGetDataSearch(`/sub-con/search/${officeId}/branch`, params );
  
  useEffect(()=>{
    let tempArr = []
    data && data.forEach(i=>{     
      tempArr.push(i?.id)
    });
    setFullList(tempArr)
  },[data])


  const defaultHeader = [
    {
      title: "ID",
      width: "5%",
      field: "id",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Company ",
      width: "10%",
      isLink: true,
      id: "id",
      link: `/main/${officeId}/contacts/sub-con/view/`,
      field: "companyName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Location",
      width: "10%",
      field: "city",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Contact Person",
      width: "10%",
      field: "contactPerson",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Mobile",
      width: "10%",
      field: "phoneWithCC",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Email",
      width: "10%",
      field: "email",
      type: "email",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Category",
      width: "10%",
      field: "category",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        id: "id",
        removeValue: "conName",
        url: "/sub-con/",
        moduleName: "Sub-Con",
        from: `/main/${officeId}/contacts/sub-con`,
        editLink: `/main/${officeId}/contacts/sub-con/edit/`,
        viewLink: `/main/${officeId}/contacts/sub-con/view/`,
      },
    },
  ]

  

  let availableHeaders = [
    
  ];

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '33px',
      height: '33px',
      fontSize: '12px',
      minWidth: '100px',
      width: '100px', 
      borderRadius: '8px',
      border: "none" 
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: '4px',
    }),
    clearIndicator: (provided) => ({
      ...provided,
      padding: '4px',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0 8px',
    }),
    input: (provided) => ({
      ...provided,
      margin: '0',
      padding: '0',
    }),
    singleValue: (provided) => ({
      ...provided,
      margin: '0',
      padding: '0',
    }),
  };

  let searchList = [
    { value: "all", label: "All" },
    { value: "services", label: "Services" },
    { value: "products", label: "Products" },
  ];

  function handleSearch(e) {
    setSearchBy(e.value);
    setParams({...params,searchBy:e.value})
  }

  useEffect(() => {
    setParams({...params,page:page,per_page:pageCount})
    localStorage.setItem("viewMode", viewMode);
  }, [page,pageCount,viewMode]);

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };
  

  const closeFilterDialogebox = () => {
    setShowExport(false);
  };

  const [showImportModal, setShowImportModal] = useState(false);

  const handleImportClick = () => {
    setShowImportModal(true);
  };

  const closeModal = () => {
    setShowImportModal(false);
  };

   const [exportValue, setExportValue] = useState({
    country:"",
    scStatus:"",
    performanceRating:"",
    subConType:"",
    category:""
    });

  const ExportFormik = useFormik({
    enableReinitialize: true,
    initialValues: exportValue,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value, { resetForm }) => {

      try {
        const response = await axiosInstance.get(`/customer-quotations/export-to-excel?approvalStatus=${value.approvalStatus}&salesPerson=${value.salesPerson}&status=${value.status}&leadTime=${value.leadTime}&validity=${value.validity}&availability=${value.availability}&paymentMethod=${value.paymentMethod}&paymentTerms=${value.paymentTerms}&deliveryTerms=${value.deliveryTerms}&fromDate=${value.fromDate}&toDate=${value.toDate}`, {
            responseType: 'blob' // Important to specify the response type as blob
        });

        // Create a Blob from the response
        const pdfBlob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        // Create a link element
       
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(pdfBlob);
        link.download = `CQ Report ${DataFormat({value:new Date(), format:"DD-MMM-YYYY"})}.xlsx`; // The filename you want for the downloaded file

        // Append the link to the body (required for Firefox)
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);

    } catch (error) {
        console.error('Error downloading the PDF:', error);
    }
    },
  });
  const [valueOfSearch,setValuesofSearch] = useState("")
  function searchFunction(e) {

    
    setValuesofSearch(e?.target?.value)
    setParams({ ...params, search: e?.target?.value, page:1 });
    setPage(1)
  }

  const navigate = useNavigate()
    
  const handleCreateClick = () => {
        navigate(`/main/${officeId}/contacts/sub-con/create`); 
          };

  return (
    <>
    <ContactsLayout 
      setOpen={setShowImportModal}
      searchFun={searchFunction}
      searchValue={valueOfSearch}
      onCreateClick={handleCreateClick} 

      getData={getData}
      isCard={true}
      isFilter={filter}
      newfilter={true}
     setFilterOpen={setShowFilterDialog}
     ClearFilter={clearFilter}
  
      CreateAccess={GetAccess("sub_contractor_create")}
      ImportAccess={GetAccess("sub_contractor_create")}
      officeId={officeId}
      setViewMode={setViewMode}
      searchBy={searchBy}
      viewMode={viewMode}
      handleSearch={handleSearch}
      // projectId={projectId}
        >
    <div className='w-full h-full '>
      {/* <div className='w-full flex justify-between items-center'>
        <Breadcrumb
          items={[
            {
              name: "Supplier",
            },

          ]}
        />
        <div className=' flex gap-2'> */}
        {/* <form
                className="flex items-center gap-3 mx-0 text-xs"
                onSubmit={SearchData}
        > */}
        {/* <Select
            options={searchList}
            value={searchList.find((i) => i.value == searchBy) || ""}
            styles={customStyles}
            className={`text-xs capitalize 2xl:text-sm font-medium `}
            onChange={handleSearch}
          />
 <SearchBar
              handleChange={(e) =>{
                setParams({ ...params, search: e.target.value, page:1 });
                setPage(1)
              }}
              value={params.search||searchQuery} 
            /> */}
             {/* </form> */}
          {/* <div className='flex gap-2'>
            <div onClick={() => setViewMode("list")} className={viewMode === "list" ? "bg-baseColor-primary h-8 w-10 rounded-md flex justify-center items-center text-white" : "bg-white h-8 w-10 rounded-md flex justify-center items-center cursor-pointer"}><List/></div>
            <div onClick={() => setViewMode("card")} className={viewMode === "card" ? "bg-baseColor-primary h-8 w-10 rounded-md flex justify-center items-center text-white" : "bg-white h-8 w-10 rounded-md flex justify-center items-center cursor-pointer"}><Card/></div>
          </div>
         
          <FilterButton  handleClick={()=>setShowFilterDialog(true)} />
          {filter && <FilterButton  handleClick={()=>clearFilter()} label='Clear'/>} */}
          {/* {GetRole() && (
                      <ExportButton handleClick={() => setShowExport(true)} />
                    )} */}
          {/* {GetRole() &&  <ImportButton handleClick={handleImportClick} />}
          {GetAccess("suppliers_create") && <Link to={`/main/${officeId}/contacts/suppliers/create/`}><CreateButton label='Supplier' /></Link>}
        </div>
      </div> */}

      {viewMode === "list" ? (
        <CustomDataTable
        fetcher={getData}
          data={data}
          //  title='Supplier'
          availableHeaders={availableHeaders}
          defaultHeader={defaultHeader}
          bodyHeight="max-h-[calc(100vh-260px)]"
          height="h-[calc(100vh-160px)]"
          total={totalCount}
          pageIndex={params.page}
          setPageIndex={setPage}
          dataCount={params.per_page}
          setDataCount={setPageCount}
          selectOneFunction={selectOneFunction}
          setShowEdit={setShowEdit}
          showEdit={showEdit}
          listofNumbers={listofNumbers}
          hasMultiEdit={GetRole()?true:false}
          selectMultipleFunction={selectMultipleFunction}
          fullList={fullList}
           getById="id"
          storageName='subconTable'
          editAccess="sub_contractor_edit"      
          deteleAccess="sub_contractor_delete" 
          dataLoading={dataLoading}
          searchQuery={params?.search!=""?params?.search:""}

        />
      ) : (
        <>
        <div className='w-full h-[calc(100vh-210px)] rounded-md bg-white p-3 mt-4 relative overflow-y-scroll'>
          <div className='flex gap-10 '>
        {/* {data && data.map((item, idx) => ( */}
         <p className='text-xs font-semibold text-[#111537] text-left'>Sub-Contractor : {totalCount}</p>
         <p className='text-xs font-semibold text-[#111537]'>Credit : {credit}</p>
         <p className='text-xs font-semibold text-[#111537]'>Advance : {advance}</p>
        

        {/* ))} */}
        </div>
          <div className='w-full flex  flex-wrap md:gap-x-5 lg:gap-x-6 gap-y-6 pt-4'>
            {data && data.map((item, idx) => (
            
              <CardView fetcher={getData} item={item} key={idx} />
            ))}
          </div>
        </div>
        <div className="w-full h-[40px] rounded-b-md bg-white">
          <Pagination
            total={totalCount}
            pageIndex={page}
            setPageIndex={setPage}
            dataCount={pageCount}
            setDataCount={setPageCount}
          />
        </div>
        </>
      )}
      </div>
      </ContactsLayout>
        {showFilterDialog && (
             
             
             <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
               <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
                 <h2 className="text-xl mb-4">Filter Sub-Contractor</h2>
                 <form onSubmit={formik.handleSubmit}> 
                    <div className="flex flex-col mb-4">
                    <FormikSelectTwo
                type="text"
                label="Type"
                placeholder="Choose"
                Options={subConType}
                formik={formik}
                name="subConType"
                  width="w-full "

              />  <FormikSelectTwo
              type="text"
              label="Category"
              placeholder="Choose"
              Options={supplierCat}
              formik={formik}
              name="category"
                width="w-full "

            />
                    <FormikSelectTwo
              Options={vendorRating}
              label="Performance Ratings"
              placeholder="Performance Ratings"
              formik={formik}
              name="performanceRating"
              width="w-full "
            />
            <FormikSelectTwo
              Options={CountryMIN}
              label="Country"
              placeholder="Country"
              formik={formik}
              name="country"
              width="w-full"
            />
              <FormikSelectTwo
              Options={scStatus}
              label="Status"
              placeholder="Status"
              formik={formik}
              name="scStatus"
              width="w-full "
            />
                    </div>
                   <div className="flex justify-end gap-2">
                     <CancelButton handleClick={closeFilterDialog} />
                     <SubmitButton name='Apply' />
                   </div>
                  </form> 
               </div>
             </div>
           )}

{showExport && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[50%] 2xl:min-w-[40%] max-w-[50%] 2xl:max-w-[40%] max-h-[80vh] relative bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <div className=" w-full flex justify-between items-center  bg-white">
              <h2 className=" text-sm 2xl:text-base font-medium ">
                Export Data
              </h2>
              <div
                className=" cursor-pointer "
                onClick={() => setShowExport(false)}
              >
                <CloseIcon />
              </div>
            </div>
            <form onSubmit={ExportFormik.handleSubmit}>
              <div className=" w-full flex flex-wrap">
                <div className=" w-full flex ">
                  <div className=" w-1/2 flex items-center px-6 py-3 ">
                    <input
                      id="default-radio-1"
                      type="radio"
                      value="all"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type =="all"}
                    />
                    <label
                      htmlFor="default-radio-1"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900 "
                    >
                      All Data
                    </label>
                  </div>

                  <div className="w-1/2 flex items-center px-6 py-3">
                    <input
                      id="default-radio-2"
                      type="radio"
                      value="filter"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type == "filter"}
                    />
                    <label
                      htmlFor="default-radio-2"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900"
                    >
                      Filter Data
                    </label>
                  </div>
                </div>
                {ExportFormik.values.type === "filter" && (
                  <>
                       <FormikSelectTwo
                type="text"
                label="Type"
                placeholder="Choose"
                Options={subConType}
                formik={ExportFormik}
                name="subConType"
                  width="w-full "

              />  <FormikSelectTwo
              type="text"
              label="Category"
              placeholder="Choose"
              Options={supplierCat}
              formik={ExportFormik}
              name="category"
                width="w-full "

            />
                    <FormikSelectTwo
              Options={vendorRating}
              label="Performance Ratings"
              placeholder="performanceRatings"
              formik={ExportFormik}
              name="performanceRating"
              width="w-full "
            />
            <FormikSelectTwo
              Options={CountryMIN}
              label="Country"
              placeholder="Country"
              formik={ExportFormik}
              name="country"
              width="w-full"
            />
             <FormikSelectTwo
              Options={user}
              label="Created By"
              placeholder="Created By"
              formik={ExportFormik}
              name="createdBy"
              width="w-full "
            />
             {/* <FormikSelectTwo
              label="Access"
              placeholder="Access"
              Options={[
                {value:"public" , label:"Public"},
                {value:"private" , label:"Private"

                }
              ]}

              formik={ExportFormik}
              name="isGeneral"
              width="w-full "
            /> */}
                       
                <FormikSelectTwo
              Options={scStatus}
              label="Status"
              placeholder="Status"
              formik={ExportFormik}
              name="scStatus"
              width="w-full "
            />
                  </>
                )}
                <div className="flex w-full justify-end gap-2">
                  <CancelButton handleClick={closeFilterDialogebox} />
                  <SubmitButton name="Export" />
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
        {showImportModal && (<Importdoc show={showImportModal} onClose={closeModal} getData={getData} />)}
        {showEdit && (<MultiEdit data={listofNumbers} getData={getData} onClose={()=>setShowEdit(false)}/>)}
 
  </>
  )
}

export default SubCon
